import { Storage } from '../../constants/storage';

const API_BASE_URL = import.meta.env.VITE_XCHANGE_API_BASE_URL || import.meta.env.VITE_AUTH_BASE_URL || 'https://api.simplize.dev';

const getAccessToken = () => {
  try {
    const auth = JSON.parse(localStorage.getItem(Storage.auth));
    return auth?.accessToken || localStorage.getItem(Storage.access_token);
  } catch {
    return localStorage.getItem(Storage.access_token);
  }
};

export const authorizedFetch = async (path, options = {}) => {
  const token = getAccessToken();
  if (!token) {
    window.location.href = '/?login=required';
    throw new Error('Not authenticated');
  }

  const url = path.startsWith('http') ? path : `${API_BASE_URL}${path}`;
  const headers = { ...options.headers, Authorization: `Bearer ${token}` };

  if (!(options.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }

  const response = await fetch(url, {
    ...options,
    headers,
    body: options.body instanceof FormData
      ? options.body
      : options.body ? JSON.stringify(options.body) : undefined,
  });

  if (response.status === 401 || response.status === 403) {
    window.location.href = '/?login=required';
    throw new Error('Session expired');
  }

  const data = await response.json();

  if (!response.ok) {
    const error = new Error(data.message || `Request failed: ${response.status}`);
    error.code = data.code;
    error.status = response.status;
    error.data = data;
    throw error;
  }

  return data;
};

export const uploadFile = async (path, formData) => {
  return authorizedFetch(path, { method: 'POST', body: formData });
};
